export default __webpack_public_path__ + "static/media/content.a005ecd9.txt";